import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'compactstring',
    standalone: false
})
export class CompactStringPipe implements PipeTransform {
	transform(val: string) {
        if (!val) return "";
        return val.replace(/\s\s+/g, ' '); 
	}
}

@Pipe({
    name: 'ticketSource'
})
export class TicketSourcePipe implements PipeTransform {
	transform(val: number) {
                if ((!val) || (val > 4) ) return "";

                var lookup = ["Email", "Chat", "Agent"];
                
                return lookup[val - 1];
	}
}